import illustration1 from 'assets/img/icons/spot-illustrations/21.png';
import illustration2 from 'assets/img/icons/spot-illustrations/16.png';
import illustration3 from 'assets/img/icons/spot-illustrations/50.png';
import illustration4 from 'assets/img/icons/spot-illustrations/48.png';

export default [
  {
    icon: ['far', 'lightbulb'],
    iconText: 'Мэдээлэл удирдах',
    color: 'danger',
    title: 'Вэбсайт дээрх агуулгыг хялбархан шинэчлэх',
    description: `Та манай GegeeWeb платформын маш хялбар энгийн ойлгомжтой интерфейс ашиглан вэбсайтын мэдээллийг шинэчлэх, засварлах боломжтой.`,
    image: illustration1
  },
  {
    icon: ['far', 'object-ungroup'],
    iconText: 'Бүтээгдэхүүний каталоги',
    color: 'info',
    title: 'Бүтээгдэхүүн болон үйлчилгээ',
    description:
      'Бүтээгдэхүүн, үйлчилгээндээ тулгуурлан каталогийн бүтэц, зохион байгуулалтыг тодорхойлон, ангилал, дэд ангилал болгон удирдах боломжтой.',
    image: illustration2,
    inverse: true
  },
  {
    icon: ['far', 'paper-plane'],
    iconText: 'Контент засах',
    color: 'success',
    title: 'Вебийн бичвэрийг өөрчлөх ',
    description:
      'Та өөрчлөхийг хүсч буй веб хуудасны контент бүрийг хялбараар засах боломжтой.',
    image: illustration3
  },
  {
    icon: ['far', 'object-ungroup'],
    iconText: 'Вебийн нийт хандалт',
    color: 'info',
    title: 'SEO & Social integration',
    description:
      'Та өөрийн бизнесийн онцлогийг тодорхойлсноор цахим орчинд өөрийн зорилтод хэрэглэгчдийн урсгалыг удирдах боломжтой.',
    image: illustration4,
    inverse: true
  }
];
